var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExamIcon = function SvgExamIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.5 10.667v2.5a3.333 3.333 0 0 1-3.333 3.333H4.833A3.333 3.333 0 0 1 1.5 13.167V4.834A3.333 3.333 0 0 1 4.833 1.5h2.5m7.5 5.834 1.322-1.322c.65-.65.65-1.706 0-2.357l-1.81-1.81a1.667 1.667 0 0 0-2.357 0l-1.321 1.322m4.166 4.167-5 5H5.667V8.167l5-5m4.166 4.167-4.166-4.167"
  })));
};
export default SvgExamIcon;